import { Route, Switch } from "react-router-dom";
import AppRoute from "./route";
import PassthroughLayout from "./PassthroughLayout";

/**
 * Persistent layout shell: keeps `layout` mounted across nested page navigations.
 * Must be used as a direct Switch child with a `path` prop (RR v5 match API).
 *
 * Full-page routes that share the same URL prefix (e.g. /admin/start) must be
 * registered in the parent Switch BEFORE this route.
 *
 * Per-route `isAuthProtected` wins when set; otherwise `isAuthProtected` prop is used.
 */
const LayoutRoute = ({
    path,
    layout: Layout,
    routes = [],
    isAuthProtected = true,
}) => {
    return (
        <Route
            path={path}
            render={() => (
                <Layout>
                    <Switch>
                        {routes.map((route, index) => (
                            <AppRoute
                                path={route.path}
                                layout={PassthroughLayout}
                                component={route.component}
                                key={`layout-route-${index}`}
                                isAuthProtected={
                                    typeof route.isAuthProtected === "boolean"
                                        ? route.isAuthProtected
                                        : isAuthProtected
                                }
                                type={route.type}
                                routeModules={route.modules}
                                routeFeatures={route.features}
                                ignoreModuleLoadingComponent={
                                    route.ignoreModuleLoadingComponent
                                }
                                exact={route.exact}
                            />
                        ))}
                    </Switch>
                </Layout>
            )}
        />
    );
};

export default LayoutRoute;
